module.exports = __webpack_public_path__ + "static/biofuel-adc498b0d3b9be21fb09d192b16311f6.png";